import { useEffect, useState } from "react";

/**
 * Returns `value` delayed by `delayMs` — re-renders only after input settles.
 * Used to keep search-as-you-type from firing a request per keystroke.
 */
export function useDebouncedValue<T>(value: T, delayMs = 250): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
